export default "__VITE_ASSET__BAolWPFv__"